var map = {
	"./01_Thusanang.jpg": 9353,
	"./02_Thusanang.jpg": 3714,
	"./03_Thusanang.jpg": 2477,
	"./04_Thusanang.jpg": 5732,
	"./05_Thusanang.jpg": 9308,
	"./06_Thusanang.jpg": 394,
	"./07_Thusanang.jpg": 6465,
	"assets/d2_SocialProject/01_Thusanang.jpg": 9353,
	"assets/d2_SocialProject/02_Thusanang.jpg": 3714,
	"assets/d2_SocialProject/03_Thusanang.jpg": 2477,
	"assets/d2_SocialProject/04_Thusanang.jpg": 5732,
	"assets/d2_SocialProject/05_Thusanang.jpg": 9308,
	"assets/d2_SocialProject/06_Thusanang.jpg": 394,
	"assets/d2_SocialProject/07_Thusanang.jpg": 6465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6244;